<div data-test-automation="tenure-new-lot-details">
    <label class="control-label">New lots / land</label>
    @if (isRoadWideningShow()) {
        <label class="control-label required-input"> Former tenure has been fully superseded by a road/widening with no lot number? </label>
    }
    @if (isRoadWideningShow() && (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
        <div>
            @for (option of fullySupersededByRoadOptions; track option; let optionId = $index) {
                <label class="nlr-radio">
                    <input
                        type="radio"
                        [id]="'fullySupersededByRoad_' + name + '_' + optionId"
                        [name]="'fullySupersededByRoad_' + name"
                        [attr.name]="'fullySupersededByRoad_' + name"
                        #fullySupersededByRoad="ngModel"
                        [value]="option.value"
                        [(ngModel)]="newLotDetails.fullySupersededByRoad"
                        [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || disabled"
                        required
                        data-test-automation="tenure-new-lot-details-fully-superseded-by-road-option-{{option.value}}" />
                    <span>{{option.name}}</span>
                    @if (fullySupersededByRoad.invalid) {
                        <div class="help-block">
                            <span>Error!</span>
                            <span>Required</span>
                        </div>
                    }
                </label>
            }
        </div>
    }
    @if (newLotDetails.fullySupersededByRoad === false) {
        <div data-test-automation="tenure-new-lot-ranges">
            @for (newLotRange of newLotDetails.newLotRanges; track newLotRange; let i = $index) {
                <div data-test-automation="tenure-new-lot-range">
                    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                        <div>
                            <div
                                class="input-group"
                                [ngClass]="{'has-error': newLotRangeInput | formFieldHasError}">
                                <span class="input-group-addon">
                                    <i class="nlrp-icon nlrp-icon-edit"></i>
                                </span>
                                <input
                                    type="text"
                                    [id]="'newLotRange_' + name + '_' + i"
                                    [name]="'newLotRange_' + name + '_' + i"
                                    [attr.name]="'newLotRange_' + name + '_' + i"
                                    #newLotRangeInput="ngModel"
                                    class="form-control"
                                    placeholder="Enter lot # or lot # range"
                                    [(ngModel)]="newLotRange.value"
                                    [nlrPattern]="lotPattern"
                                    [disabled]="(['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions) || disabled" />
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-add"
                                        [ngClass]="{'disabled': disabled || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)}"
                                        title="Add lot range"
                                        (click)="!disabled && addLotRange(i)"
                                        data-test-automation="tenure-add-lot-range"></i>
                                </span>
                                <span class="input-group-addon">
                                    <i
                                        class="nlrp-icon nlrp-icon-remove"
                                        [ngClass]="{'disabled': disabled || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)}"
                                        title="Remove lot range"
                                        (click)="!disabled && removeLotRange(i)"
                                        data-test-automation="tenure-remove-lot-range"></i>
                                </span>
                            </div>
                            @if (newLotRangeInput?.errors?.['nlrPattern']) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Invalid</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
